export default __webpack_public_path__ + "static/media/SignupCarouselSS1.119209c0.svg";